/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '@mairistem/composants';
import { Bloc } from '@mairistem/administres-utils';

import { baseUrlApp } from '@/routes';
import { useEntiteStore } from '@/zustand';

interface BlocCreationRecenseProps {
  style?: React.CSSProperties;
}

const BlocCreationRecense = ({ style }: BlocCreationRecenseProps) => {
  const history = useHistory();

  const selectedEntite = useEntiteStore((state) => state.selectedEntite);

  const handleClick = React.useCallback(() => {
    history.push(`${baseUrlApp}recenses/assistant`);
  }, [history]);

  return (
    <Bloc
      icon="group"
      header={`Saisie d'un nouveau recensé ${!_.isNil(selectedEntite) ? `pour l'entité ${selectedEntite?.libelle}` : ''}`}
      style={style}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Button
          primary
          icon="plus"
          color="blue"
          size="big"
          content="Ajouter un recensé"
          onClick={handleClick}
          data-testid="button-nouveau-recense"
          className="custom-blue-button"
          style={{ width: 'auto', borderRadius: '8px' }}
        />
      </div>
    </Bloc>
  );
};

export default BlocCreationRecense;
